




















import { Vue, Prop, Component } from 'vue-property-decorator';

@Component({})
export default class ArrowLink extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
  @Prop({ default: 'none' }) readonly fill?: string;
  @Prop({ default: 'right' }) readonly direction!:
    | 'down'
    | 'left'
    | 'right'
    | 'up';

  get transformStyle() {
    const translate = {
      left: 180,
      right: 0,
      down: 90,
      up: -90
    }[this.direction];

    return `transform: rotate(${translate}deg)`;
  }
}
